import { createTheme, Shadows } from '@mui/material/styles';

const darkThemeCustom = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFFFFF' // Set primary color to white
    },
    secondary: {
      main: '#8ec222' // Set secondary color to green
    },
    background: {
      paper: '#1A1C20', // Set the DataGrid background
      default: '#111418' // Set the background
    },
    text: {
      primary: '#FFFFFF', // Set text color to white
      secondary: '#FFFFFF' // Set secondary text color to white
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          padding: '8px 16px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          margin: '6px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }
      }
    }
  },

  shadows: Array(25).fill('none') as Shadows
});

// Export the theme with CSS variables
const darkThemeWithCssVars = {
  ...darkThemeCustom,
  cssVars: {
    '--color-primary': darkThemeCustom.palette.primary.main,
    '--color-secondary': darkThemeCustom.palette.secondary.main,
    '--color-background': darkThemeCustom.palette.background.default,
    '--color-paper': darkThemeCustom.palette.background.paper,
    '--color-text-primary': darkThemeCustom.palette.text.primary,
    '--color-text-secondary': darkThemeCustom.palette.text.secondary,
    '--color-button': darkThemeCustom.palette.primary.main,
    '--color-modal-background': 'rgb(0,10,0)'
  }
};

export default darkThemeWithCssVars;
